import axios from 'axios'
import { BUSCAR_VEICULOS_DISPONIVEIS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarVeiculosDisponiveis (empresaId) {
  const url = `${URL}/agendamento-viagem/empresa/${empresaId}/veiculo`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_VEICULOS_DISPONIVEIS,
        payload: response

      })
  );
}
